/**
 * Runtime detection for GPU/memory-constrained browsers.
 *
 * Why: iOS Safari/Chrome share the same WebKit engine and impose a tight
 * per-tab GPU memory budget (~256–384 MB). A full-quality export that combines
 * an 8192² VSM shadow map (~512 MB at half-float) with a 2× supersampled MSAA
 * framebuffer crosses the budget and the OS kills the WebGL context — the tab
 * crashes mid-export. Clamping against `gl.capabilities.maxTextureSize` alone
 * is not enough: newer iPhones report 8192 or 16384 there, so the cap never
 * triggers but the actual allocation still fails. We need a UA-based check.
 *
 * Android Chrome is not flagged here — current reports show it completes the
 * full-quality export, so we don't trade quality for safety we don't need.
 */
export const isIosDevice = (): boolean => {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent
  if (/iPhone|iPad|iPod/.test(ua)) return true
  // iPadOS 13+ reports as "Macintosh" but exposes touch input
  return ua.includes('Macintosh') && navigator.maxTouchPoints > 1
}
